import { Dialog, DialogPortal } from '@/components/ui/dialog'
import * as DialogPrimitive from '@radix-ui/react-dialog'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

interface SignupFieldInfoDialogProps {
  isOpen: boolean
  onOpenChange: (open: boolean) => void
  title: string
  description: string
}

export function SignupFieldInfoDialog({
  isOpen,
  onOpenChange,
  title,
  description
}: SignupFieldInfoDialogProps) {
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogPortal>
        <DialogPrimitive.Overlay
          className={cn(
            "fixed inset-0 z-[110] bg-black/50 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0"
          )}
        />
        <DialogPrimitive.Content
          className={cn(
            "fixed left-0 right-0 top-[50%] z-[111] translate-y-[-50%] border-none bg-background shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-top-[48%] rounded-[var(--card-radius)] p-6 overflow-hidden mx-auto",
            "max-w-[calc(var(--max-content-width)+var(--min-side-padding)*2)]",
            "w-[90vw]"
          )}
        >
          {/* Content */}
          <div className="space-y-4">
            <h2 className="text-lg font-semibold text-foreground">
              {title}
            </h2>
            <p className="text-sm text-foreground/80 leading-relaxed">
              {description}
            </p>

            {/* Close Button */}
            <Button
              onClick={() => onOpenChange(false)}
              className="w-full bg-primary hover:bg-primary/90 text-primary-foreground"
            >
              Got it!
            </Button>
          </div>
        </DialogPrimitive.Content>
      </DialogPortal>
    </Dialog>
  )
}

